import { NextPageContext } from 'next'
import { SmartroundGetUrlResultResponse } from '../../types'
import { printError } from '../log'
import { basePath, callAuthAPI } from './common'

export const getSmartroundUrl = async (
  ctx: NextPageContext,
  corporateNumber: string | null
) => {
  if (corporateNumber == null) {
    return null
  }
  try {
    const response = await callAuthAPI<SmartroundGetUrlResultResponse>(
      ctx,
      `${basePath}/smartround/${corporateNumber}`
    )
    return response.publicUrl
  } catch (e) {
    printError(e)
    return null
  }
}
